const featureFlagged = "fleet_web_app:feature_flag:read:";

const Permissions = {
  all: null,
  featureFlag: featureFlagged,
  readVehicles: null,
  writeVehicles: null,
  readFleets: "vehicle_api:fleets:read:",
  writeFleets: "vehicle_api:fleets:write:",
  readFirmware: "vehicle_api:firmware:read:",
  writeFirmware: "vehicle_api:firmware:write:",
  writeHibernate: "vehicle_api:vehicles_hibernation:write:",
  readRidersAdmin: "consumer_auth:riders_admin:read:",
  writeRidersAdmin: "consumer_auth:riders_admin:write:",
  deleteRidersAdmin: "consumer_auth:riders_admin:delete:",
  readWallet: "billing_service_confidential:wallet:read:",
  writeWallet: "billing_service_confidential:wallet:write:",
  cashoutWallet: "billing_service_confidential:wallet:cashout:",
  readRatePlans: "billing_service_confidential:rate_plan:read:",
  writeRatePlans: "billing_service_confidential:rate_plan:write:",
  readPromos: "billing_service_confidential:coupon:read:",
  writePromos: "billing_service_confidential:coupon:write:",
  vehicleCommandRequest: "vehicle_api:commands:request:",
  readReservations: "vehicle_api:reservations:read:",
  readToastMessages: "vehicle_api:toasts:read:",
  writeToastMessages: "vehicle_api:toasts:write:",
  writeGeofences: "vehicle_api:zones:write:",
  readPasses: "billing_service_confidential:pass:read:",
  readPassOffers: "billing_service_confidential:pass_offer:read:",
  readPassOfferTypes: "billing_service_confidential:pass_offer_type:read:",
  writePasses: "billing_service_confidential:pass:write:",
  writePassOffers: "billing_service_confidential:pass_offer:write:",
  writePassOfferTypes: "billing_service_confidential:pass_offer_type:write:",
  cashoutPasses: "billing_service_confidential:pass:cashout:",
  basicWrite: "vehicle_registration:basic:write:",
  adminWrite: "vehicle_registration:admin:write:",
  readParkingIncentives: "billing_service_confidential:parking_incentive:read:",
  writeParkingIncentives: "billing_service_confidential:parking_incentive:write:",
  readTripEvents: "vehicle_api:trips:read:event_path",
  writeFineType: "billing_service_confidential:fine_type:write",
  issueFine: "billing_service_confidential:transaction:write:fine",
  feature: {
    otaPage: window.REACT_APP_FF_OTA_PAGE ? featureFlagged : null,
    geofenceCreation: window.REACT_APP_FF_GEOFENCE_CREATION ? featureFlagged : null,
    lockTo: window.REACT_APP_FF_LOCK_TO ? featureFlagged : null,
    passes: window.REACT_APP_FF_PASSES ? featureFlagged : null,
    messaging: window.REACT_APP_FF_MESSAGING ? featureFlagged : null,
    scheduleGeofenceRules: window.REACT_APP_FF_SCHEDULE_GEOFENCE_RULES ? featureFlagged : null,
    manageAccount: window.REACT_APP_FF_MANAGE_ACCOUNT ? featureFlagged : null,
    viewCommandHistory: window.REACT_APP_FF_VIEW_COMMAND_HISTORY ? featureFlagged : null,
    sidewalks: window.REACT_APP_FF_SIDEWALKS ? featureFlagged : null,
  },
};

export default Permissions;
